/* src/contexts/profile/profileContextSetup.js */
import { createContext, useContext } from 'react';

// 1. Create the context object with a default value (can be null or a default structure)
export const ProfileContext = createContext(null);

// 2. Create a custom hook for consuming the context
export const useProfile = () => {
  const context = useContext(ProfileContext);
  // Ensure the hook is used within the provider
  if (!context) {
    throw new Error('useProfile must be used within a ProfileProvider');
  }
  return context;
};